import Lookup from "../../entities/lookup";

/**
 * Lookup actions
 *
 * Call order:
 *
 * LOOKUP_SAVE_QUEUE:	adds the item to the save queue
 * --> LOOKUP_SAVE:	modifies the state
 * --> LOOKUP_SAVE_SUCCESS: if all went well
 * --> LOOKUP_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail LOOKUP_SAVE_QUEUE is during the call to LOOKUP_SAVE,
 * as adding an item to the queue should never fail.
 */

export const LOOKUP_FETCH_ONE_QUEUE: any = 'LOOKUP_FETCH_ONE_QUEUE';
export const LOOKUP_FETCH_SUCCESS: any = 'LOOKUP_FETCH_SUCCESS';
export const LOOKUP_FETCH_FAILURE: any = 'LOOKUP_FETCH_FAILURE';
export const LOOKUP_FETCH_ONE_SUCCESS: any = 'LOOKUP_FETCH_ONE_SUCCESS';
export const LOOKUP_FETCH_ONE_FAILURE: any = 'LOOKUP_FETCH_ONE_FAILURE';

export const LOOKUP_SAVE: any = 'LOOKUP_SAVE';
export const LOOKUP_SAVE_QUEUE: any = 'LOOKUP_SAVE_QUEUE';
export const LOOKUP_SAVE_SUCCESS: any = 'LOOKUP_SAVE_SUCCESS';
export const LOOKUP_SAVE_FAILURE: any = 'LOOKUP_SAVE_FAILURE';

export const LOOKUP_SAVE_MANY: any = 'LOOKUP_SAVE_MANY';
export const LOOKUP_SAVE_MANY_QUEUE: any = 'LOOKUP_SAVE_MANY_QUEUE';
export const LOOKUP_SAVE_MANY_SUCCESS: any = 'LOOKUP_SAVE_MANY_SUCCESS';
export const LOOKUP_SAVE_MANY_FAILURE: any = 'LOOKUP_SAVE_MANY_FAILURE';

export const LOOKUP_REMOVE: any = 'LOOKUP_REMOVE';
export const LOOKUP_REMOVE_QUEUE: any = 'LOOKUP_REMOVE_QUEUE';
export const LOOKUP_REMOVE_SUCCESS: any = 'LOOKUP_REMOVE_SUCCESS';
export const LOOKUP_REMOVE_FAILURE: any = 'LOOKUP_REMOVE_FAILURE';

export const LOOKUP_RESTORE: any = 'LOOKUP_RESTORE';
export const LOOKUP_RESTORE_QUEUE: any = 'LOOKUP_RESTORE_QUEUE';
export const LOOKUP_RESTORE_SUCCESS: any = 'LOOKUP_RESTORE_SUCCESS';
export const LOOKUP_RESTORE_FAILURE: any = 'LOOKUP_RESTORE_FAILURE';

export const LOOKUP_RESTORE_MANY: any = 'LOOKUP_RESTORE_MANY';
export const LOOKUP_REMOVE_MANY: any = 'LOOKUP_REMOVE_MANY';

/* Fetch actions */
export const fetchLookupSuccess = (lookups: Lookup[], partial: boolean, lastFetch: number) => ({type: LOOKUP_FETCH_SUCCESS, lookups, partial, lastFetch});
export const fetchLookupFailure = (err: any) => {
		console.error('LookupAction: fetchLookupFailure', err);
		return {type: LOOKUP_FETCH_FAILURE, err};
};
export const fetchOneLookupQueue = (lookupId: string) => ({type: LOOKUP_FETCH_ONE_QUEUE, lookupId});
export const fetchOneLookupSuccess = (lookup: Lookup) => ({type: LOOKUP_FETCH_ONE_SUCCESS, lookup});
export const fetchOneLookupFailure = (id: string, err: any) => {
		console.error('LookupAction: fetchOneLookupFailure', err);
		return {type: LOOKUP_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveLookup = (lookup: Lookup) => {
    // console.debug('⮂ LOOKUP_SAVE action', lookup?.id);
    return {type: LOOKUP_SAVE, lookup};
}
export const saveLookupQueue = (lookup: Lookup) => {
    // console.debug('⮂ LOOKUP_SAVE_QUEUE action', lookup?.id);
    return {type: LOOKUP_SAVE_QUEUE, lookup};
}
export const saveLookupSuccess = (lookup: Lookup) => {
    // console.debug('⮂ LOOKUP_SAVE_SUCCESS action', lookup?.id);
    return {type: LOOKUP_SAVE_SUCCESS, lookup};
}
export const saveLookupFailure = (lookup: Lookup, status: number, message: string) => {
    console.warn(`⮂ LOOKUP_SAVE_FAILURE error saving lookup: HTTP ${status}: ${message}`, lookup?.id);
    return {type: LOOKUP_SAVE_FAILURE, lookup, status, message};
};

/* SaveMany actions */
export const saveManyLookups = (lookups: Lookup[]) => {
    // console.debug('⮂ LOOKUP_SAVE_MANY action', lookups?.map(lookup => lookup?.id).join(','));
    return {type: LOOKUP_SAVE_MANY, lookups};
}
export const saveManyLookupsQueue = (lookups: Lookup[]) => {
    // console.debug('⮂ LOOKUP_SAVE_MANY_QUEUE action', lookups?.map(lookup => lookup.id).join(','));
    return {type: LOOKUP_SAVE_MANY_QUEUE, lookups};
}

export const saveManyLookupsSuccess = (lookups: Lookup[]) => {
    // console.debug('⮂ LOOKUP_SAVE_MANY_SUCCESS action', lookups?.map(lookup => lookup.id).join(','));
    return {type: LOOKUP_SAVE_MANY_SUCCESS, lookups};
}
export const saveManyLookupsFailure = (lookups: Lookup[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_LOOKUPS_FAILURE Error saving lookups: HTTP ${status}: ${message}`, lookups?.map(lookup => lookup.id).join(','));
		return {type: LOOKUP_SAVE_MANY_FAILURE, lookups, status, message};
};

/* Remove actions */
export const removeLookup = (lookup: Lookup) => ({ type: LOOKUP_REMOVE, lookup });
export const removeLookupQueue = (lookup: Lookup) => ({ type: LOOKUP_REMOVE_QUEUE, lookup });
export const removeLookupSuccess = (lookup: Lookup) => ({ type: LOOKUP_REMOVE_SUCCESS, lookup });
export const removeLookupFailure = (lookup: Lookup, status: number, message: string) => {
	console.error(`Redux: removeLookupFailure Error removing lookup: HTTP ${status}: ${message}`);
	return ({ type: LOOKUP_REMOVE_FAILURE, lookup, status, message });
};

/* Restore actions */
export const restoreLookup = (lookup: Lookup) => ({ type: LOOKUP_RESTORE, lookup });
export const restoreLookupQueue = (lookup: Lookup) => ({ type: LOOKUP_RESTORE_QUEUE, lookup });
export const restoreLookupSuccess = (lookup: Lookup) => ({ type: LOOKUP_RESTORE_SUCCESS, lookup });
export const restoreLookupFailure = (lookup: Lookup, status: number, message: string) => {
	console.error(`Redux: restoreLookupFailure Error restoring lookup: HTTP ${status}: ${message}`);
	return ({ type: LOOKUP_RESTORE_FAILURE, lookup, status, message });
};

/* RestoreMany actions */
export const restoreManyLookups = (lookups: Lookup[]) => ({ type: LOOKUP_RESTORE_MANY, lookups });

/* RemoveMany actions */
export const removeManyLookups = (lookups: Lookup[]) => ({ type: LOOKUP_REMOVE_MANY, lookups });